<template>
  <div class="table-stats">
    <div
      v-if="loading"
      style="padding: 0 0 15px 0"
    >
      <v-progress-linear
        indeterminate
        :color="enterpriseColor"
      />
      <center>
        <small :style="{ color: enterpriseColor}">{{info}}</small>
      </center>
    </div>
      <div style="padding: 10px 10px 0 10px;">
      <v-layout wrap style="background-color: #CCCCCC80;padding: 15px; 10px;border-radius:5px;">
        <v-flex xs6 style="padding-right: 20px;">
        <v-select
          v-model="selectedDateFilter"
          :items="datesFilter"
          :label="$t('dashboard.stats.month')"
          item-text="Name"
          item-value="ID"
          hide-details
          dense
        />
        </v-flex>
        <v-flex xs6>
        <v-select
          v-if="sources && sources.length > 0" 
          :items="sources"
          v-model="selectedSource"
          label="Identificador"
          dense
          hide-details
          item-text="Name"
          item-value="ID"
          @change="handleGetStats" 
        />
        </v-flex>
        </v-layout>
      </div>
      <v-simple-table v-if="menus">
      <thead>
        <tr>
          <th class="text-left" style="font-weight:300">{{ $t('dashboard.stats.menu') }}</th>
          <th class="text-center" style="font-weight:300">{{ $t('dashboard.stats.clicks') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in menus" :key="item.ID" style="padding-top:5px;">
          <td class="text-left">{{ item.Name }}</td>
          <td class="text-center">{{ loading ? '...' : item.Clicks }}</td>
        </tr>
      </tbody>
    </v-simple-table>
    <v-layout wrap 
      style="padding-top: 20px;"
    >
      <v-flex xs6
        style="padding-left: 20px;"
      >
        <stats-m-month-v2
          :workspaceID="workspaceID" 
          :sources="sources"
        />
      </v-flex>
      <v-flex xs6
        style="padding-right: 20px;"
      >
        <click-export 
          v-if="dataToExcel"
          :data="dataToExcel"
        />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
  import axios from 'axios'
  import i18n from '@/plugins/i18n'
  import _ from 'lodash'
  import api from '@/services/api'
  import utils from '@/services/utils'
  import ClickExport from './ClickExport'
  import StatsMMonthV2 from './StatsMMonthV2'
  export default {
    components: {
      ClickExport,
      StatsMMonthV2,
    },
    props: {
      workspaceID: {
        type: String,
        required: true
      },
      sources: {
        type: Array,
        default: null,
      },
    },
    data: () => ({
      loading: false,
      menus: null,
      stats: null,
      today: new Date(),
      key: 0,
      dates: null,
      dataToExcel: null,
      datesFilter: [],
      selectedDateFilter: null,
      info: null,
      selectedSource: null,
    }),
    computed: {
      locale () {
        return i18n.locale
      },
      enterpriseColor() {
        return this.$store.state.app.enterpriseColor
      },
    },
    watch: {
      workspaceID () {
        this.handleGetMenus()
      },
      selectedDateFilter (v) {
        if (!v) return
        this.handleGetStats()
      },
      sources () {
        this.selectedSource = null
      },
    },
    mounted () {
      this.prepareSelect() 
      this.handleGetMenus()
    },
    methods: {
      prepareSelect () {
        const result = [{ ID: { year: null, month: null }, Name: 'Todos' }]
        let i = 0
        let today = new Date()
        let year = today.getFullYear()
        while (i < 1000 && year >= 2019) {
          today = new Date()
          const newDate = new Date(today.setMonth(today.getMonth() -i))
          year = newDate.getFullYear()
          let month = newDate.getMonth() + 1
          result.push({ ID: { year, month}, Name: `${year} / ${month}` })
          i++
        }
      this.datesFilter = result
      this.selectedDateFilter = this.datesFilter[1].ID
      },
      getTranslation(v, locale) {
        return utils.getTranslation(v, locale)
      },
      handleGetMenus () {
        api.getAll(`workspaces/${this.workspaceID}/menus`, 1, 10000)
          .then(response => {
            const results = []
            const aux = response.filter(x => x.Name).map(item => {
              return {
                ID: item.ID,
                Name: item.Name ? utils.getTranslation(JSON.parse(item.Name), this.locale) : null,
                ORD: item.ORDPrimary,
                ParentID: item.ParentID,
              }
            })
            for (const item of aux.filter(x => !x.ParentID).sort((a, b) => { return parseInt(a.ORD) - parseInt(b.ORD)})) {
              results.push(item)
              results.push(
                ...aux.filter(x => x.ParentID === item.ID).map(i => {
                 i.Name = `${item.Name} / ${i.Name}`
                    return i
                }).sort((a, b) => { return parseInt(a.ORD) - parseInt(b.ORD)})
              )
              
            }
            this.menus = results
            this.handleGetStats()
          })
          .catch(error => {
            console.log(error)
          })
      },
      async handleGetStats () {
        this.info = null
        const baseURL = 'https://cm-dtouch-stats-api.dtouch.es'
        //const baseURL = 'http://localhost:3805'
        if (!this.selectedDateFilter || !this.menus) return

        this.menus = this.menus.map(item => {
          item.Clicks = '...'
          return item
        })

        const { year, month } = this.selectedDateFilter
        if (!year && !month) {
          this.loading = true
          let i = 0
          for (const item of this.datesFilter.filter(x => x.ID.year).map(item => item.ID)) {
            i++
            this.info = `[${i} / ${this.datesFilter.length}]`
            const aux = await new Promise((resolve, reject) => axios.get(`${baseURL}/v1/public/stats/menu-count/m/${this.workspaceID}/${item.year}/${item.month}/${this.selectedSource ? this.selectedSource : ''}`)
              .then(response => {
                resolve(response.data)
              })
              .catch(error => {
                console.log(error)
                reject(error)
              }))

            this.menus = this.menus.map(item => {
              const count = aux.filter(x => x.MenuID === item.ID).map(item => item.Count).shift()
              item.Clicks = (item.Clicks && item.Clicks !== '...' ? item.Clicks : 0) + (count ? count : 1)
              return item
            })

                this.dataToExcel = this.menus.map(item => {
                  return {
                    MENUS: item.Name,
                    CLICKS: item.Clicks,
                  }
                })
          }
          this.loading = false
        } else {
          this.loading = true
          const url = `${baseURL}/v1/public/stats/menu-count/m/${this.workspaceID}/${year}/${month}/${this.selectedSource ? this.selectedSource : ''}`
          axios.get(url)
            .then(response => {
              this.menus = this.menus.map(item => {
                const count = response.data.filter(x => x.MenuID === item.ID).map(item => item.Count).shift()
                item.Clicks = count ? count : 0
                return item
              })

                this.dataToExcel = this.menus.map(item => {
                  return {
                    MENUS: item.Name,
                    CLICKS: item.Clicks,
                  }
                })

              this.loading = false
            })
            .catch(error => {
              console.log(error)
            })
        }
      },
    }
  }
</script>
<style>
  .table-stats td {
    vertical-align: middle !important;
  }
  .v-sheet--offset {
    top: -24px;
    position: relative;
  }
</style>
